<div class="input-field">
  <div class="horizontal-layout">
    <label *ngIf="label" class="label">{{ label }}</label>
    <ng-content select="[header-slot]"></ng-content>
  </div>

  <ng-content></ng-content>
</div>
